import mutations from './mutations'
import * as actions from './actions'
import moment from 'moment'

const state = {
  steps: [
   
  ],
  quote_list_admin: [],
  car_model_list: [],
  selectedAdminQuote : {},
  quote_state_law: {},
  paqAccessToken: null,
}

export default {
  state,
  mutations,
  actions,
}




// WEBPACK FOOTER //
// ./src/store/modules/quotes/index.js